import { render, staticRenderFns } from "./MenuComplete.vue?vue&type=template&id=8984c3fa&scoped=true"
import script from "./MenuComplete.vue?vue&type=script&lang=js"
export * from "./MenuComplete.vue?vue&type=script&lang=js"
import style0 from "./MenuComplete.vue?vue&type=style&index=0&id=8984c3fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8984c3fa",
  null
  
)

export default component.exports